import { environment } from 'src/environment'
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { loadStripe } from '@stripe/stripe-js';
import { StripeIdealBankComponent } from 'ngx-stripe';
import { SettingsService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-ideal-pay',
  templateUrl: './ideal-pay.component.html',
  styleUrls: ['./ideal-pay.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass]
})
export class IdealPayComponent implements OnInit {

  @ViewChild(StripeIdealBankComponent) bank: StripeIdealBankComponent;
  @ViewChild('idealBankElement') idealBankElement: ElementRef;
  stripe: import("@stripe/stripe-js").Stripe;
  idealEmptyError = true;
  proceedPayment = false;
  @Input() page = '';

  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, private settingsService: SettingsService,
    private paymentService: PaymentService) { }

  ngOnInit(): void {
    let textColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-font-color-on-lbg');
    let bgColor =  getComputedStyle(document.documentElement).getPropertyValue('--bg-page');
    let placeHolderColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-font-color');
    const options = {
      style: {
        base: {
          padding: '10px 12px',
          color: textColor,
          fontSize: '16px',
          backgroundColor: bgColor,
          lineHeight: '0.9',
          '::placeholder': {
            color: placeHolderColor
          },
        },
      },
    };
    const publishableKey = this.settingsService.stripeKey;
    loadStripe(publishableKey).then(res => {
      this.paymentService.stripe = res;
      const stripeElement = this.paymentService.stripe.elements({ locale: this.configService.stripeLocaleCode });
      this.paymentService.idealBank = stripeElement.create('idealBank', options);
      this.paymentService.idealBank.mount('#ideal-bank-element');
      this.paymentService.idealBank.on('change', (event) => {
        this.idealEmptyError = event['empty'];
      });
    });
  }

}
